import { Component, DestroyRef, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { GlobalConstants } from 'src/app/common/global';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Services } from "src/app/services/api.service";
import { ActivatedRoute, Router } from '@angular/router';
import { membershipTypes } from 'src/app/common/constants';
import { CommonModule } from '@angular/common';
import { CountriesStore } from 'src/app/services/countries.store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorMessageService } from 'src/app/services/error-message.util';
import { strictEmailValidator } from 'src/app/utils/validators';
import { GetUserProfileService } from 'src/app/services/getUserProfile.service';
import { UserProfile } from 'src/app/common/interfaces';
import { Country } from 'src/app/common/countries.model';
import { trimAllControls } from 'src/app/utils/trim-values.util';
import { TranslateModule } from '@ngx-translate/core';

interface SelectedDelivery {
  id: string;
  enterData: boolean, 
  foreignDelivery: boolean
}

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.sass'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, TranslateModule]
})

export class DeliveryComponent {
  userProfileTypeList: any = [];

  deliveryForm = this.formBuilder.group({
    email: ['', [ Validators.required, strictEmailValidator ]],
    firstName: ['', [ Validators.required ]],
    lastName: ['', [ Validators.required ]],
    street: ['', [ Validators.required ]],
    houseNo: ['', [ Validators.required ]],
    city: ['', [ Validators.required ]],
    postNo: ['', [ Validators.required ]],
    country: ['', [ Validators.required ]],
    phoneNo: ['', [ Validators.required ]],
    deliveryWay: ['', []],  
    termsOfSale: [false],
    footnote: ['']
  });

  acceptImageTerms: boolean = false;
  loader = document.getElementById("loader-container");
  errorMessage: string = "";
  deliveryData: any;
  selectedDelivery: SelectedDelivery = {
    id: "",
    enterData: false,
    foreignDelivery: false
  }
  countryList: Country[] = [];
  countryListCopy: Country[] = [];
  orderId = document.location.pathname.split("/buy-membership/")[1];
  //deliveryDataFromSessionStorage:any = sessionStorage.getItem("membershipData");
  showConditionTerms: boolean = false;
  showConditionTermsW01: boolean = false;
  renewMembership: boolean = false;
  membershipTypes = membershipTypes;
  @Input() orderIdFromParent: any;
  profileType: string = (this.route.snapshot.queryParams['type'] === "club-friend") ? membershipTypes.CLUB_FRIEND : membershipTypes.FULL_FLEDGED;
  private readonly destroyRef = inject(DestroyRef);
  @Output() emitShowPaymentOnModalForMembership = new EventEmitter<any>();
  private userProfile: UserProfile | null = null;

  constructor(
    private formBuilder: FormBuilder, 
    public services: Services, 
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private readonly countriesStore: CountriesStore,
    private readonly errorMessageService: ErrorMessageService,
    private readonly getUserProfileService: GetUserProfileService 
  ) {
    const conditionTerms = sessionStorage.getItem("acceptTerms");

    if(conditionTerms) {
      this.showConditionTerms = JSON.parse(conditionTerms);
    }
    
    this.countriesStore.fetchCountries().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(response => {
      this.countryList = response;
      this.countryListCopy = response;
    })
  }

  ngOnInit() {
    this.getUserProfileService.getUserProfile().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(profile => {
      this.userProfile = profile;
    });

    this.getDeliveryInfo();
  }

  onSubmit() {
    const controls = this.deliveryForm.controls;
    trimAllControls(this.deliveryForm);

    if (!controls['deliveryWay'].value) {
      this.errorMessage = this.errorMessageService.getErrorMessage('allFieldsRequired');
      return;
    }

    if (this.selectedDelivery.enterData || this.showConditionTermsW01) {
      if (this.deliveryForm.invalid) {
        this.deliveryForm.markAllAsTouched();

        if (this.selectedDelivery.id === 'W01' && !controls['termsOfSale'].value) {
          this.errorMessage = this.errorMessageService.getErrorMessage('termsOfSaleRequired');
        } else if (controls['email'].hasError('invalidEmail')) {
          this.errorMessage = this.errorMessageService.getErrorMessage('invalidEmailFormat');
        } else {
          this.errorMessage = this.errorMessageService.getErrorMessage('allFieldsRequired');
        }
        return;
      }
    }

    this.errorMessage = "";
    this.loader!.style.display = "flex";
    this.postDeliveryData();
  }

  postDeliveryData() {
    let body = JSON.stringify({
      'deliveryId': this.selectedDelivery.id,
      'deliveryData': {
        "email": this.deliveryForm.value.email,
        "ime": this.deliveryForm.value.firstName,
        "prezime": this.deliveryForm.value.lastName,
        "adresa": this.deliveryForm.value.street,
        "kucni_broj": this.deliveryForm.value.houseNo,
        "mjesto": this.deliveryForm.value.city,
        "pbr": this.deliveryForm.value.postNo,
        "drzava": this.deliveryForm.value.country,
        "tel": this.deliveryForm.value.phoneNo,
        "napomena": this.deliveryForm.value.footnote,
      }
    })    
      
    this.http.post(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderId}/delivery`, body, GlobalConstants.headersCentral).subscribe({
      next: data => {
        let response:any = data;          
        if(response.success === true) {

          this.emitShowPaymentOnModalForMembership.emit();
          this.loader!.style.display = "none";
        } else if (response.success === false) {
          this.errorMessage = this.errorMessageService.getErrorMessage('error');

          this.loader!.style.display = "none";
        }
      }, error: error => {
        if(error.status === 401) {
          //this.Services.logout();
        }
        this.loader!.style.display = "none";
        this.errorMessage = this.errorMessageService.getErrorMessage('error');
      }
    })
  }

  getDeliveryInfo() {
    this.loader!.style.display = "flex";
    if(this.orderId === undefined) {
      this.orderId = this.orderIdFromParent;
    }

    this.http.get(`${environment.apiUrl}/conn/${environment.connId}/v1/orders/${this.orderIdFromParent}/delivery`, GlobalConstants.headersCentral).subscribe({
      next: data => {
        let response:any = data;
        this.deliveryData = response.data.deliveryData;
        const alreadySelectedDelivery = response.data.deliveryData.some((item:any) => item.primjenjena === true);
        const objectFromSessionStorage = sessionStorage.getItem("deliveryData");
        if(alreadySelectedDelivery && objectFromSessionStorage && (JSON.parse(objectFromSessionStorage).brdok === this.orderId)) {
          //document.location = `${environment.redirectUrl}/buy-membership/cart/${(JSON.parse(objectFromSessionStorage).newBrdok)}`;
        } else {
          sessionStorage.removeItem("removeData");   
        }

        this.loader!.style.display = "none";
      },
      error: error => {
      }
    })
  }

  checkValue(event: any){
    if(event.target.checked) {
      this.errorMessage = "";
    }
  }

  checkRenewMembership(event: any) {
    this.renewMembership = event.target.checked;
  }

  changeDeliveryWay(id:string, enterData: boolean, foreignDelivery: boolean) {
    if (id === 'W03') {
      this.countryListCopy = this.countryList.filter(country => country.name === 'Hrvatska');
    } else if (id === 'W04') {
      this.countryListCopy = this.countryList.filter(country => country.name !== 'Hrvatska');
    } else if (id === 'W02') {
      this.countryListCopy = [...this.countryList];
    }

     let countryIso: string;

    if (enterData && this.userProfile) {
      const userCountry = this.userProfile.country;

      switch (id) {
        case 'W03':
          // Always select Croatia
          countryIso = this.countryListCopy[0].isoCharCode;
          break;

        case 'W04':
          if (userCountry !== 'Hrvatska') {
            // Preselect user's country
            const foreignCountry = this.countryListCopy.find(country => country.name === userCountry);
            countryIso = foreignCountry ? foreignCountry.isoCharCode : this.countryListCopy[0].isoCharCode;
          } else {
            // If user is Croatian, preselect first in list
            countryIso = this.countryListCopy[0].isoCharCode;
          }
          break;

        case 'W02': {
          // Preselect user's country; fallback to Croatia
          const userMatch = this.countryListCopy.find(c => c.name === userCountry);
          if (userMatch) {
            countryIso = userMatch.isoCharCode;
          } else {
            const cro = this.countryListCopy.find(country => country.name === 'Hrvatska')!;
            countryIso = cro.isoCharCode;
          }
          break;
        }

        default:
          countryIso = this.countryListCopy[0].isoCharCode;
      }

    } else {
      countryIso = this.countryListCopy[0].isoCharCode;
    }

    this.deliveryForm.patchValue({ country: countryIso });

    this.selectedDelivery = { id, enterData, foreignDelivery };
    this.errorMessage = "";
    if (id === 'W01' && this.showConditionTerms) {
      this.showConditionTermsW01 = true;
    }

    if (enterData && this.userProfile) {
      this.deliveryForm.patchValue({
        firstName: this.userProfile.firstName,
        lastName: this.userProfile.lastName,
        street: this.userProfile.address,
        houseNo: this.userProfile.houseNo,
        city: this.userProfile.city,
        postNo: this.userProfile.postNo,
        phoneNo: this.userProfile.phoneNo,
        email: this.userProfile.email
      });
    }
  }

  removeErrorMessage(eventTarget:any) {
    this.errorMessage = "";
  }

  removeCountryErrorMessage() {
    this.errorMessage = "";
  }

  cancelOrder() {
    this.services.cancelOrder( this.orderId, false, {changeUrl: false, url: ""});
  }
}